import { all } from 'redux-saga/effects';
import * as Eff from 'redux-saga/effects';
import {
  loadUserSaga,
  saveUserSaga,
  swapCustomerViewTypeSaga,
  tokenValidateSaga,
  userLogoutSaga
} from './user/sagas';
import { Types as UserTypes } from './user/types';
import { Types as AccessManagementTypes } from './access-management/types';
import { Types as CustomersTypes } from './customers/types';
import { Types as CreditLimitsTypes } from './credit-limits/types';
import { Types as OrdersTypes } from './long-steel-orders/types';
import { Types as InvoicesTypes } from './invoices/types';
import { Types as LongSteelShoppingCartTypes } from './long-steel-shopping-cart/types';
import { Types as OrderItemSeachTypes } from './long-steel-order-item-search/types';
import { Types as DashboardTypes } from './dashboard/types';
import { Types as DownloadAreaTypes } from './download-area/types';
import { Types as MockupType } from './fabrication-mockups/types';
import { Types as ProjectType } from './fabrication-projects/types';
import { Types as FabricationOrderTypes } from './fabrication/types';
import { Types as FabricationContractsTypes } from './fabrication-contracts/types';
import { Types as ContractsAndConstructionsTypes } from './contracts-and-constructions/types';
import { Types as FabricationPurchaseOrderTypes } from './fabrication-purchase-order/types';
import { Types as FabricationOrdersTypes } from './fabrication-orders/types';
import { Types as TaggingTypes } from './tagging/types';
import { Types as ObservabilityTypes } from './observability/types';
import { Types as LoyaltyTypes } from './loyalty/types';
import { Types as OrderSimulatedCheckoutMvpTypes } from './order-simulate-checkout-mvp/types';
import { Types as AuthTypes } from './auth/types';
import { sendTaggingSaga } from './tagging/sagas';
import {
  loadCustomersSaga,
  loadCustomerFromIdSaga,
  loadCustomersProductDescription,
  loadCustomersProductDescriptionV2,
  loadCustomerBlocks,
  loadCustomerPurchaseReceiversSaga
} from './customers/sagas';
import {
  loadCreditLimitsSaga,
  requestRenewCreditSaga
} from './credit-limits/sagas';
import {
  loadInvoicesDuplicatesSaga,
  loadInvoiceCreditsSaga,
  loadNFFileFromFinancialsSaga,
  loadInvoiceBilletSaga,
  filterDuplicatesByDateSaga,
  loadInvoiceXMLSaga
} from './invoices/sagas';
import {
  updateLongSteelShoppingCartSaga,
  loadLongSteelShoppingCartFromLocalStorageSaga,
  sendLongSteelOrderSaga
} from './long-steel-shopping-cart/sagas';
import {
  loadLongSteelOrdersSaga,
  loadTrackingFlatSteelSaga,
  loadBilledOrderTrackingSaga,
  loadLongSteelOrdersFromLocalStorageSaga,
  loadQCFileSaga,
  loadNFFileSaga,
  loadShippingNoteFileSaga,
  loadTrackingLongSteelSaga,
  loadCgQualityCertificateSaga
} from './long-steel-orders/sagas';
import {
  faceliftSearchItemsSaga,
  loadLastOrdersSaga,
  searchItemsFromLastOrderSaga,
  searchItemsSaga,
  searchItemsSpreadsheetSaga,
  searchItemsSpreadSheetSagaMVP
} from './long-steel-order-item-search/sagas';
import {
  loadBilledByDaySaga,
  loadBilledByMonthSaga,
  loadDuplicatesByDaySaga,
  loadDuplicatesSaga,
  loadOpenOrderStatusBySkuSaga,
  loadOpenOrderStatusSaga,
  loadPaidByMonthSaga
} from './dashboard/sagas';
import { loadProjectsSaga } from './fabrication-projects/sagas';
import {
  createCustomerUserSaga,
  loadCustomerUsersSaga,
  removeCustomerUserSaga,
  updateCustomerUserPermissionSaga
} from './access-management/sagas';
import {
  loadPieceTypesSaga,
  loadSteelTypeDiametersSaga,
  loadSteelTypesSaga,
  loadWireTypesSaga
} from './fabrication/sagas';
import { sendFabricationPurchaseOrderSaga } from './fabrication-purchase-order/sagas';
import {
  loadFabricationContractByContractNumberSaga,
  loadFabricationContractByContractNumberV2Saga,
  loadFabricationContractDetailsSaga,
  loadFabricationContractDetailsV2Saga,
  loadFabricationContractsSaga,
  loadFabricationContractsV2Saga
} from './fabrication-contracts/sagas';
import {
  loadCustomerContractsSaga,
  loadCustomerContractsSagaV2,
  sendConstructionRegistrationSaga
} from './contracts-and-constructions/sagas';
import {
  loadFabricationOrdersSaga,
  loadNFFileFromFabricationOrderDeliverySaga,
  loadFabricationOrderByIdSaga
} from './fabrication-orders/sagas';
import {
  saveFabricationMockupSaga,
  loadFabricationMockupSaga,
  removeFabricationMockupSaga,
  editPavementsSaga
} from './fabrication-mockups/sagas';
import {
  setObservabilitySaga,
  errorObservabilitySaga
} from './observability/sagas';
import {
  loadBilletFileSaga,
  loadCustomerBilletsSaga,
  loadCustomerNfsAndQualityCertificatesSaga,
  loadDownloadQCFileSaga,
  loadNFFileSaga as loadNFFileSagaFromDownloadArea,
  loadNFXMLFileSaga
} from './download-area/sagas';
import {
  loadLoyaltyRewardsSaga,
  loadLoyaltyGoalSaga,
  loadLoyaltyHistorySaga,
  loadLoyaltyProductSaga,
  loadLoyaltyProductSimulateSaga,
  loadLoyaltyWithdrawSaga,
  loadLoyaltySendWithdrawSaga
} from './loyalty/sagas';
import {
  requestOrdersSentSaga,
  updateCheckoutStateLocalStorage
} from './order-simulate-checkout-mvp/sagas';
import { loadAuthSateSaga, refreshAuthTokenSaga } from './auth/sagas';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const takeLatest: any = Eff.takeLatest;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const takeEvery: any = Eff.takeEvery;

export default function* rootSaga() {
  yield all([
    // Auth
    // takeLatest(AuthTypes.LOAD_AUTH_STATE, loadAuthSateSaga),
    takeLatest(AuthTypes.REFRESH_AUTH_TOKEN_REQUEST, refreshAuthTokenSaga),

    // Users
    takeLatest(UserTypes.TOKEN_VALIDATE, tokenValidateSaga),
    takeLatest(UserTypes.LOAD_USER, loadUserSaga),
    takeLatest(UserTypes.SAVE_USER, saveUserSaga),
    takeLatest(UserTypes.USER_LOGOUT, userLogoutSaga),
    takeLatest(UserTypes.SWAP_USER_VIEW_TYPE, swapCustomerViewTypeSaga),

    // Access acessManagement
    takeLatest(
      AccessManagementTypes.LOAD_CUSTOMER_USERS,
      loadCustomerUsersSaga
    ),
    takeLatest(
      AccessManagementTypes.CREATE_CUSTOMER_USER,
      createCustomerUserSaga
    ),
    takeEvery(
      AccessManagementTypes.UPDATE_CUSTOMER_USER_PERMISSION,
      updateCustomerUserPermissionSaga
    ),
    takeLatest(
      AccessManagementTypes.REMOVE_CUSTOMER_USER,
      removeCustomerUserSaga
    ),

    // Customers
    takeLatest(CustomersTypes.LOAD_CUSTOMERS, loadCustomersSaga),
    takeLatest(CustomersTypes.LOAD_CUSTOMER_BY_ID, loadCustomerFromIdSaga),
    takeLatest(
      CustomersTypes.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION,
      loadCustomersProductDescription
    ),
    takeLatest(
      CustomersTypes.LOAD_CUSTOMER_PRODUCTS_DESCRIPTION_V2,
      loadCustomersProductDescriptionV2
    ),
    takeLatest(CustomersTypes.LOAD_CUSTOMER_BLOCKS, loadCustomerBlocks),
    takeLatest(
      CustomersTypes.LOAD_CUSTOMER_PURCHASE_RECEIVERS,
      loadCustomerPurchaseReceiversSaga
    ),

    // Dashboard
    takeLatest(DashboardTypes.LOAD_OPEN_ORDER_STATUS, loadOpenOrderStatusSaga),
    takeLatest(
      DashboardTypes.LOAD_OPEN_ORDER_STATUS_BY_SKU,
      loadOpenOrderStatusBySkuSaga
    ),
    takeLatest(DashboardTypes.LOAD_BILLED_BY_MONTH, loadBilledByMonthSaga),
    takeLatest(DashboardTypes.LOAD_PAID_BY_MONTH, loadPaidByMonthSaga),
    takeLatest(DashboardTypes.LOAD_DUPLICATES, loadDuplicatesSaga),
    takeLatest(DashboardTypes.LOAD_BILLED_BY_DAY, loadBilledByDaySaga),
    takeLatest(DashboardTypes.LOAD_DUPLICATES_BY_DAY, loadDuplicatesByDaySaga),

    // Download Area
    takeLatest(
      DownloadAreaTypes.LOAD_CUSTOMER_NFS_AND_QUALITY_CERTIFICATES,
      loadCustomerNfsAndQualityCertificatesSaga
    ),
    takeLatest(
      DownloadAreaTypes.LOAD_CUSTOMER_BILLETS,
      loadCustomerBilletsSaga
    ),
    takeEvery(DownloadAreaTypes.LOAD_QC_FILE, loadDownloadQCFileSaga),
    takeEvery(DownloadAreaTypes.LOAD_BILLET_FILE, loadBilletFileSaga),
    takeEvery(DownloadAreaTypes.LOAD_NF_FILE, loadNFFileSagaFromDownloadArea),
    takeEvery(DownloadAreaTypes.LOAD_NF_XML_FILE, loadNFXMLFileSaga),

    // Orders
    takeLatest(
      OrdersTypes.LOAD_LONG_STEEL_ORDERS_FROM_LOCAL_STORAGE,
      loadLongSteelOrdersFromLocalStorageSaga
    ),
    takeLatest(OrdersTypes.LOAD_LONG_STEEL_ORDERS, loadLongSteelOrdersSaga),
    takeEvery(OrdersTypes.LOAD_TRACKING_FLAT_STEEL, loadTrackingFlatSteelSaga),
    takeEvery(OrdersTypes.LOAD_TRACKING_LONG_STEEL, loadTrackingLongSteelSaga),
    takeEvery(
      OrdersTypes.LOAD_BILLED_ORDER_TRACKING,
      loadBilledOrderTrackingSaga
    ),
    takeEvery(OrdersTypes.LOAD_QC_FILE, loadQCFileSaga),
    takeEvery(OrdersTypes.LOAD_NF_FILE, loadNFFileSaga),
    takeEvery(OrdersTypes.LOAD_SHIPPING_NOTE_FILE, loadShippingNoteFileSaga),
    takeEvery(OrdersTypes.CG_QC_FILE_REQUEST, loadCgQualityCertificateSaga),

    // Invoices
    takeLatest(InvoicesTypes.LOAD_DUPLICATES, loadInvoicesDuplicatesSaga),
    takeLatest(
      InvoicesTypes.FILTER_DUPLICATES_BY_DATE,
      filterDuplicatesByDateSaga
    ),
    takeLatest(InvoicesTypes.LOAD_INVOICE_CREDITS, loadInvoiceCreditsSaga),
    takeEvery(InvoicesTypes.LOAD_NF_FILE, loadNFFileFromFinancialsSaga),
    takeEvery(InvoicesTypes.LOAD_INVOICE_BILLET, loadInvoiceBilletSaga),
    takeEvery(InvoicesTypes.LOAD_INVOICE_XML, loadInvoiceXMLSaga),
    takeLatest(CreditLimitsTypes.LOAD_CREDIT_LIMITS, loadCreditLimitsSaga),
    takeLatest(
      CreditLimitsTypes.REQUEST_RENEW_CREDIT_LIMITS,
      requestRenewCreditSaga
    ),

    // Order Item Search
    takeLatest(OrderItemSeachTypes.SEARCH_ITEM, searchItemsSaga),
    takeLatest(
      OrderItemSeachTypes.FACELIFT_SEARCH_ITEM,
      faceliftSearchItemsSaga
    ),
    takeLatest(
      OrderItemSeachTypes.SEARCH_ITEM_SPREADSHEET,
      searchItemsSpreadsheetSaga
    ),
    takeLatest(
      OrderItemSeachTypes.SEARCH_ITEM_SPREADSHEET_MVP,
      searchItemsSpreadSheetSagaMVP
    ),
    takeLatest(OrderItemSeachTypes.LOAD_LAST_ORDERS, loadLastOrdersSaga),
    takeLatest(
      OrderItemSeachTypes.SEARCH_ITEMS_FROM_LAST_ORDER,
      searchItemsFromLastOrderSaga
    ),

    // Fabrication
    takeLatest(FabricationOrderTypes.LOAD_PIECE_TYPES, loadPieceTypesSaga),
    takeLatest(FabricationOrderTypes.LOAD_STEEL_TYPES, loadSteelTypesSaga),
    takeEvery(
      FabricationOrderTypes.LOAD_STEEL_TYPE_DIAMETERS,
      loadSteelTypeDiametersSaga
    ),
    takeLatest(FabricationOrderTypes.LOAD_WIRE_TYPES, loadWireTypesSaga),

    // Fabrication contracts
    takeLatest(
      FabricationContractsTypes.LOAD_CONTRACTS,
      loadFabricationContractsSaga
    ),
    takeLatest(
      FabricationContractsTypes.LOAD_CONTRACTS_V2,
      loadFabricationContractsV2Saga
    ),
    takeLatest(
      FabricationContractsTypes.LOAD_CONTRACT_DETAILS,
      loadFabricationContractDetailsSaga
    ),
    takeLatest(
      FabricationContractsTypes.LOAD_CONTRACT_DETAILS_V2,
      loadFabricationContractDetailsV2Saga
    ),
    takeLatest(
      FabricationContractsTypes.LOAD_CONTRACT_BY_CONTRACT_NUMBER,
      loadFabricationContractByContractNumberSaga
    ),
    takeLatest(
      FabricationContractsTypes.LOAD_CONTRACT_BY_CONTRACT_NUMBER_V2,
      loadFabricationContractByContractNumberV2Saga
    ),

    // Contracts and Constructions
    takeLatest(
      ContractsAndConstructionsTypes.FINISH_CONSTRUCTION_REGISTRATION,
      sendConstructionRegistrationSaga
    ),
    takeLatest(
      ContractsAndConstructionsTypes.LOAD_CUSTOMER_CONTRACTS,
      loadCustomerContractsSaga
    ),
    takeLatest(
      ContractsAndConstructionsTypes.LOAD_CUSTOMER_CONTRACTS_V2,
      loadCustomerContractsSagaV2
    ),

    // Fabrication orders
    takeLatest(
      FabricationOrdersTypes.LOAD_FABRICATION_ORDERS,
      loadFabricationOrdersSaga
    ),
    takeEvery(
      FabricationOrdersTypes.LOAD_NF_FILE_FROM_FABRICATION_ORDERS,
      loadNFFileFromFabricationOrderDeliverySaga
    ),

    takeLatest(
      FabricationOrdersTypes.LOAD_FABRICATION_ORDERS_BY_ID,
      loadFabricationOrderByIdSaga
    ),

    // Long Steel Shopping cart
    takeLatest(
      LongSteelShoppingCartTypes.LOAD_FROM_LOCAL_STORAGE,
      loadLongSteelShoppingCartFromLocalStorageSaga
    ),
    takeLatest(
      LongSteelShoppingCartTypes.UPDATE_SHOPPING_CART_SETTINGS,
      updateLongSteelShoppingCartSaga
    ),
    takeLatest(LongSteelShoppingCartTypes.FINISH_ORDER, sendLongSteelOrderSaga),

    takeLatest(
      LongSteelShoppingCartTypes.CLEAN_SHOPPING_CART,
      updateLongSteelShoppingCartSaga
    ),

    // Fabrication Purchase Order
    takeLatest(
      FabricationPurchaseOrderTypes.FINISH_ORDER,
      sendFabricationPurchaseOrderSaga
    ),

    // Mockups
    takeLatest(MockupType.SAVE_FABRICATION_MOCKUP, saveFabricationMockupSaga),
    takeLatest(MockupType.LOAD_FABRICATION_MOCKUPS, loadFabricationMockupSaga),
    takeLatest(
      MockupType.REMOVE_FABRICATION_MOCKUPS,
      removeFabricationMockupSaga
    ),

    // Projects
    takeLatest(ProjectType.LOAD_FABRICATION_PROJECTS, loadProjectsSaga),

    // Pavements
    takeLatest(MockupType.EDIT_PAVEMENT_STATUS, editPavementsSaga),

    // Loyalty
    takeLatest(LoyaltyTypes.LOAD_LOYALTY_REWARDS, loadLoyaltyRewardsSaga),
    takeLatest(LoyaltyTypes.LOAD_LOYALTY_GOAL, loadLoyaltyGoalSaga),
    takeLatest(LoyaltyTypes.LOAD_LOYALTY_PRODUCT, loadLoyaltyProductSaga),
    takeLatest(
      LoyaltyTypes.LOAD_LOYALTY_PRODUCT_SIMULATE,
      loadLoyaltyProductSimulateSaga
    ),
    takeLatest(LoyaltyTypes.LOAD_LOYALTY_HISTORY, loadLoyaltyHistorySaga),
    takeLatest(LoyaltyTypes.LOAD_LOYALTY_WITHDRAW, loadLoyaltyWithdrawSaga),
    takeLatest(
      LoyaltyTypes.LOAD_LOYALTY_SEND_WITHDRAW,
      loadLoyaltySendWithdrawSaga
    ),

    // Tagging
    takeEvery(TaggingTypes.SEND_TAGGING, sendTaggingSaga),

    // Observability
    takeLatest(
      ObservabilityTypes.SET_OBSERVABILITY_INITIALIAZED,
      setObservabilitySaga
    ),

    // checkout
    takeLatest(
      OrderSimulatedCheckoutMvpTypes.REQUEST_FINALIZE_SALE,
      requestOrdersSentSaga
    ),
    takeLatest(
      OrderSimulatedCheckoutMvpTypes.UPDATE_CHECKOUT_STATE_LOCAL_STORAGE,
      updateCheckoutStateLocalStorage
    ),

    // Errors
    takeEvery(ObservabilityTypes.OBSERVABILITY_ERROR, errorObservabilitySaga)
  ]);
}
